export const GET_ASSESSMENT_PAGE = 'GET_ASSESSMENT_PAGE';
export const FETCH_ASSESSMENT_PAGE_START = 'FETCH_ASSESSMENT_PAGE_START';
export const FETCH_ASSESSMENT_PAGE_SUCCESS = 'FETCH_ASSESSMENT_PAGE_SUCCESS';
export const FETCH_ASSESSMENT_PAGE_ERROR = 'FETCH_ASSESSMENT_PAGE_ERROR';

export const CHECK_CATEGORY_CHANGE = 'CHECK_CATEGORY_CHANGE';
export const CHECK_SELECTION = 'CHECK_SELECTION';
export const PAGE_CHANGE = 'PAGE_CHANGE';
export const SCALE_CHANGE = 'SCALE_CHANGE';
export const SET_EXTERNAL_ID = 'SET_EXTERNAL_ID';
export const SET_PREV_EXTERNAL_ID = 'SET_PREV_EXTERNAL_ID';
export const SET_QUALITY_CHECK_TABNAME = 'SET_QUALITY_CHECK_TABNAME';
export const TOGGLE_BORDERS_VISIBILITY = 'TOGGLE_BORDERS_VISIBILITY';

export const SET_UNIT_BOX_COORDINATES = 'SET_UNIT_BOX_COORDINATES';
export const ADD_SSI_UNIT = 'ADD_SSI_UNIT';
export const REMOVE_SSI_UNIT = 'REMOVE_SSI_UNIT';
export const UPDATE_SSI_UNIT_RESULT = 'UPDATE_SSI_UNIT_RESULT';
export const UPDATE_SSI_UNIT_TEXT_USED = 'UPDATE_SSI_UNIT_TEXT_USED';
export const UPDATE_SSI_UNIT_TEXT_REQUIRED = 'UPDATE_SSI_UNIT_TEXT_REQUIRED';

export const IMPORT_ASSESSMENT_PAGES = 'IMPORT_ASSESSMENT_PAGES';
